import { DotIcon, Undo2Icon, XIcon } from 'lucide-react'
import { PropsWithChildren } from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { avatarChipVariants } from '@/components/lemmala-design-system/avatar/variants'
import { Tooltip } from '@/components/lemmala-design-system/tooltip/tooltip'

export type UserBaseBadgeProps = {
  name: string
  email?: string
  onRemove?: () => void
  onRestore?: () => void
  disabled?: boolean
  isOnline?: boolean
  tooltipDisabled?: boolean
  onClick?: () => void
} & PropsWithChildren

export const UserBadgeBase = ({
  name,
  email,
  onRemove,
  onRestore,
  disabled,
  isOnline,
  tooltipDisabled = false,
  onClick,
  children,
}: UserBaseBadgeProps) => {
  return (
    <Tooltip
      tooltipDisabled={tooltipDisabled}
      trigger={
        <div className={avatarChipVariants({ clickable: Boolean(onClick) })} onClick={onClick}>
          <div className={cn('flex items-center gap-1', disabled && 'opacity-50')}>{children}</div>
          {disabled && onRestore && (
            <Undo2Icon
              strokeWidth={2.5}
              size={16}
              className='cursor-pointer rounded p-0.5 text-main-foreground-primary'
              onMouseDown={(e) => e.stopPropagation()}
              onClick={onRestore}
            />
          )}
          {!disabled && onRemove && (
            <XIcon
              size={16}
              className='cursor-pointer rounded p-0.5 text-main-foreground-primary'
              onMouseDown={(e) => e.stopPropagation()}
              onClick={onRemove}
            />
          )}
          {isOnline && (
            <DotIcon size={12} strokeWidth={8} className='text-main-foreground-success' />
          )}
        </div>
      }
    >
      <div className='flex flex-col items-center gap-1'>
        <span className='font-semibold'>{name}</span>
        {email && <span>{email}</span>}
      </div>
    </Tooltip>
  )
}
